import config from '@/config'

export function redirect(slug) {
  window.location = config.urls.homepage.replace('//', '//'+slug+'.')
}
